import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function CoinFlip() {
  const [pick, setPick] = useState(null);
  const [coin, setCoin] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [streak, setStreak] = useState(0);
  const { refreshMe } = useAuth();

  const flip = async (choice) => {
    setPick(choice); setBusy(true); setResult(null);
    setTimeout(async () => {
      const c = Math.random() < 0.5 ? "heads" : "tails";
      setCoin(c);
      const won = c === choice;
      setResult(won ? "win" : "lose");
      setStreak(s => won ? s + 1 : 0);
      setBusy(false);
      try {
        await api.post("/games/result", { game_slug: "coinflip", won });
        if (won) refreshMe();
      } catch {}
    }, 700);
  };

  return (
    <div data-testid="game-coinflip" className="bg-black/60 border border-white/10 rounded-md p-6 max-w-md mx-auto text-center">
      <div className="sc-heading text-2xl font-bold mb-2">Coin Flip</div>
      <div className="text-xs text-zinc-400 mb-6">Pick heads or tails · free play, no wager</div>
      <div className="text-7xl my-8" style={{ animation: busy ? "spin 0.6s linear infinite" : "none" }}>
        {coin === "heads" ? "🪙" : coin === "tails" ? "💿" : "❓"}
      </div>
      {coin && <div className="text-zinc-400 text-sm mb-4">Landed on: <span className="text-white font-bold">{coin}</span></div>}
      {result === "win" && <div className="text-[#10B981] font-bold mb-2">Correct! Streak: {streak}</div>}
      {result === "lose" && <div className="text-[#FF3366] font-bold mb-2">Wrong call</div>}
      <div className="flex gap-3 justify-center">
        <button data-testid="coinflip-heads" disabled={busy} onClick={() => flip("heads")} className="sc-btn flex-1">Heads</button>
        <button data-testid="coinflip-tails" disabled={busy} onClick={() => flip("tails")} className="sc-btn-ghost flex-1">Tails</button>
      </div>
      <style>{`@keyframes spin { from { transform: rotateY(0); } to { transform: rotateY(360deg); } }`}</style>
    </div>
  );
}
